<div class="page-body-wrapper" [rvIsLoading]="listDataService.loading">
  @if (displayMode$ | async; as displayMode) {
    <ng-container *ngTemplateOutlet="header; context: { totalItemCount: listDataService.totalCount, displayMode: displayMode }"/>
    @if (listDataService.data; as items) {
      @if (items.length > 0) {
        <ng-container *ngTemplateOutlet="(displayMode$ | async) === 'grid' ? grid : list; context: { items: items }"/>
      } @else {
        <div class="empty">No favorites</div>
      }
    }
    <rn-pager/>
  }
  <ng-container *ngTemplateOutlet="commandBar"/>
</div>


<ng-template #header let-itemCount="totalItemCount" let-displayMode="displayMode">
  <div class="grid-header">
    <div class="mat-headline-4">Favorites ({{ itemCount || 0 }})</div>
    <div class="grid-controls">
      <rn-grid-list-select [displayMode]="displayMode" (displayModeChange)="setDisplayMode($event)"/>
      <rn-favorites-page-size-select/>
    </div>
  </div>
</ng-template>

<ng-template #grid let-items="items">
  <rn-favorites-grid [items]="items"/>
</ng-template>

<ng-template #list let-items="items">
  <div class="items item-list">
    <!-- Must track by $index because items could contain duplicate records. -->
    @for (item of items; track $index) {
      <rn-list-item [catalogRecord]="item" [topBorder]="$first"/>
    }
  </div>
</ng-template>

<ng-template #commandBar>
  <div class="clear-for-footer"></div> <!-- clear space for the fixed footer -->
  <div class="save-footer flex-row flex-center-center" style="height: 100px; background-color: white">
    <div class="button-row-right" style="max-width: var(--content-width); width: 100%;">
      <button id="clearFavoritesBtn" mat-raised-button color="primary" class="ButtonSmallBlack save-button-group save-button"
              [disabled]="!listDataService.data.length" (click)="clearFavorites()">
        Clear all Favorites
      </button>
    </div>
  </div>
</ng-template>
